import { css } from "styled-components";

/**
 * New look (phones): turns an antd table into stacked rows. The header is
 * hidden (sorting moves to a sort pill), every row becomes a grid whose areas
 * the table names, and cells marked with `data-label` render as detail lines
 * with a muted label on the left and the value on the right.
 */
export const phoneStackedRows = css`
  .ant-table-thead {
    display: none;
  }
  .ant-table-content {
    overflow: visible !important;
  }
  .ant-table-content > table {
    min-width: 0 !important;
    width: 100% !important;
    table-layout: auto !important;
  }
  colgroup {
    display: none;
  }
  .ant-table-tbody > tr.ant-table-row {
    display: grid;
    align-items: center;
    column-gap: 6px;
    row-gap: 6px;
    padding: 14px 4px 14px 12px;
    border-bottom: ${(p) => p.theme.borders.lightest};
  }
  .ant-table-tbody > tr.ant-table-row > td {
    display: block;
    width: auto !important;
    min-width: 0;
    padding: 0 !important;
    border: none !important;
    background: transparent !important;
  }
  td[data-label] {
    display: flex !important;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    min-height: 28px;
    padding-right: 8px !important;
    font-size: 13px;
  }
  td[data-label]::before {
    content: attr(data-label);
    flex: none;
    color: ${(p) => p.theme.colors.secondaryText};
    font-size: 12.5px;
  }
`;
